export const InboxPhoneCallView = () => {
  return <div>Temp phone page</div>;
};
